<template>
  <component
    v-bind = "containerTag.props"
    :is = "containerTag.name">
    <slot name = "before-name" />
    <component
      v-bind = "{...parrierTag.props, ...customBind.name || {} }"
      :is = "parrierTag.name">
      <v-text-field
        v-bind = "{ ...customBind.nameInput || {} , ...textFieldProps}"
        v-model = "input.name"
        :rules = "rules.name"
        placeholder = "Intent Name" />
    </component>
    <slot
      v-for = "(slot, s) in new Array(slots)"
      :name = "`tail-slot-${ s + 1 }`" />
  </component>
</template>

<script>
const isValidIntentName = function(val) {
  return !!(val.match(/([a-z]|_|\.){1,}/) && val.match(/([a-z]|_|\.){1,}/)[0] === val) || 'Please enter a lowercase name with underscore or dots.'
}
export default {
  name: 'AddIntent',
  props: {
    containerTag: {
      type: Object,
      default() {
        return {
          name: 'div',
          props: {
            class: ''
          }
        }
      }
    },
    parrierTag: {
      type: Object,
      default() {
        return {
          name: 'div',
          props: {
            class: ''
          }
        }
      }
    },
    textFieldProps: {
      type: Object,
      default() {
        return {
          outline: true
        }
      }
    },
    slots: {
      type: Number,
      default: 2
    },
    customBind: {
      type: Object,
      default() {
        return {}
      }
    },
    put: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      isValid: false,
      input: {
        name: ''
      },
      rules: {
        name: [
          isValidIntentName
        ]
      }
    }
  },
  watch: {
    put(val) {
      if (val) this.input = val
      else this.resetForm()
    }
  },
  methods: {
    submit() {
      if (isValidIntentName(this.input.name)) {
        this.emitLoading(true)
        const payload = this.put ? { name: this.put.name, id: this.put.id } : { ...this.input }
        this.$store.dispatch(`nlp/intents/${this.put ? 'update' : 'add'}`, payload)
        .then((response)=>{
          this.resetForm()
          this.emitLoading(false)
          this.$emit('success', response.data)
        })
        .catch((err) => {
          this.emitLoading(false)
          this.$store.dispatch('setErrorMessage', true)
          this.$emit('error', err)
        })
      }
    },
    async resetForm() {
      this.input = {
        name: ''
      }
      return true
    },
    emitLoading(status = true) {
      this.$emit('loading', status)
    }
  }
}
</script>

<style lang="css" scoped>
</style>
